import { Box } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const ChatMessageBubble = styled(Box, {
  shouldForwardProp: prop => prop !== '$incoming',
})<{ $incoming: boolean }>(({ theme, $incoming }) => ({
  backgroundColor: $incoming
    ? alpha(theme.palette.primary.main, 0.5)
    : theme.palette.background.messageBubble,
  borderRadius: theme.shape.borderRadius * 1.5,
  maxWidth: '50%',
  padding: theme.spacing(1.5),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(1),
  },
}));
